






















































































































































































































































































































































































































































































































import moment from 'moment'
import { Vue } from 'vue-property-decorator'
import { MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import {
  WarehouseMaterialStockServiceProxy,
  WarehouseLocationServiceProxy,
  WarehouseAreaServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import {
  StockInOrderMaterialServiceProxy,
  StockOutOrderServiceProxy
} from '@/service-proxies/app-v2/wms.service-proxies'
import { putFile } from '@/api/api'
import _, { rest } from 'lodash'
import { ProductionPlanServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import {
  ROfOssFile,
  ServiceProxy as ResourceServiceProxy
} from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()
const msp = new MaterialServiceProxy()
const whmssp = new WarehouseMaterialStockServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
const whasp = new WarehouseAreaServiceProxy()
const siomsp = new StockInOrderMaterialServiceProxy()
const ppsp = new ProductionPlanServiceProxy()
const soosp = new StockOutOrderServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'key',
    scopedSlots: { customRender: 'key' },
    ellipsis: true,
    width: 100,
    fixed: 'left'
  },
  {
    title: 'page_material_warehousing_material_bar',
    dataIndex: 'barCode',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_type',
    dataIndex: 'materialTypeName',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_code',
    dataIndex: 'materialCode',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_name',
    dataIndex: 'materialName',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_batch',
    dataIndex: 'batchCode',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'batchCode' }
  },
  {
    title: 'page_material_warehousing_to_check',
    dataIndex: 'isMustCheck',
    ellipsis: true,
    customRender: (item) => {
      return item == 1 ? '是' : '否'
    },
    width: 150
  },
  {
    title: 'page_material_warehousing_specifications',
    dataIndex: 'materialStandardModel',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_unit',
    dataIndex: 'materialUnit',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_totalNum',
    dataIndex: 'totalNum',
    ellipsis: true,
    scopedSlots: { customRender: 'totalNum' },
    width: 150
  },
  {
    title: 'page_material_warehousing_stockInNum',
    dataIndex: 'stockInNum',
    ellipsis: true,
    scopedSlots: { customRender: 'stockInNum' },
    width: 150
  },
  {
    title: 'page_material_warehousing_price',
    dataIndex: 'price',
    ellipsis: true,
    scopedSlots: { customRender: 'price' },
    width: 150
  },
  {
    title: 'page_material_warehousing_remark',
    dataIndex: 'remark',
    ellipsis: true,
    scopedSlots: { customRender: 'remark' },
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'areaId',
    ellipsis: true,
    scopedSlots: { customRender: 'areaId' },
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'locationId',
    ellipsis: true,
    scopedSlots: { customRender: 'locationId' },
    width: 150
  },
  {
    title: 'supplier',
    dataIndex: 'supplierId',
    ellipsis: true,
    scopedSlots: { customRender: 'supplierId' },
    width: 150
  },
  {
    title: 'page_material_warehousing_testResult',
    dataIndex: 'testResult',
    ellipsis: true,
    scopedSlots: { customRender: 'testResult' },
    width: 150
  },
  {
    title: 'page_material_warehousing_fileName',
    dataIndex: 'fileName',
    ellipsis: true,
    scopedSlots: { customRender: 'fileName' }
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      count: 1,
      dataSource: [],
      cacheData: [],
      valueMaterial: '',
      nameMaterial: '',
      chooseVisible: false,
      editingKey: '',
      materialList: [],
      materialAddList: [],
      areaList: [], // 库区列表
      locationList: [], // 库位列表
      loading: false,
      canAdd: true,
      canAddMaterial: true,
      isPlan: false,
      planList: [], // 计划列表
      inTypeCode: '',
      selectPlan: '',
      planInfo: {},
      customerList: [], // 客户列表
      orderList: [], // 工单列表
      selectOrder: '',
      processList: [], // 工序列表
      selectProcess: '',
      stockOutOrderList: [], // 出库单列表
      isPlanAdd: true,
      canAddTwo: false,
      hasOutOrder: false
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    areaId: String,
    defaultData: Object,
    staff: Array,
    depts: Array,
    stockInList: Array,
    selectId: String,
    supplierList: Array
  },
  computed: {
    columns() {
      return columns.map((item) => {
        if (item.dataIndex === 'isMustCheck') {
          item.customRender = (text) => {
            if (text) {
              return text === 1 ? this.$t('yes') : this.$t('no')
            }
          }
        }
        if (this.hasOutOrder) {
          if (item.dataIndex === 'totalNum') {
            item.title = 'page_plan_delivery_quantity'
            item.dataIndex = 'stockOutNum'
          }
        } else {
          if (item.dataIndex === 'stockOutNum') {
            item.title = 'page_material_warehousing_totalNum'
            item.dataIndex = 'totalNum'
          }
        }
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    dDate() {
      return this.defaultData.receivingTime ? moment(this.defaultData.receivingTime) : moment()
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getALLMaterial()
          whasp.listWarehouseArea('').then((res) => {
            this.areaList = res
          })
          this.getPlanList()
          this.getStockOutOrder()
          this.checkMaterialBuff()
        }
      },
      deep: true,
      immediate: true
    },
    defaultData(val) {
      this.dataSource = []
      const data = this.addTT(val.stockInOrderMaterialVoList) || []
      this.dataSource = data
      this.count = this.dataSource.length
      this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
    }
  },
  methods: {
    // 初始化
    getStockOutOrder() {
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      soosp.pageStockOutOrder(areaId, 1, '', 999999).then((res) => {
        this.stockOutOrderList = res.records
      })
    },
    getPlanList() {
      const values: any = {
        typeId: null,
        filterPlus: false,
        planStatus: ['1', '2', '3', '4', '6'],
        param: {}
      }
      ppsp.page(1, values, 9999).then((res) => {
        this.planList = res.records
      })
    },
    async getALLMaterial() {
      this.materialList = await msp.getMaterialList(0, '', undefined, '')
      this.materialList.map((item) => {
        if (item.standardModel) {
          const str = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})——${item.standardModel}(${this.$t('page_material_warehousing_specifications')})`
          this.materialAddList.push({ id: item.id, code: str })
        } else {
          const str = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})`
          this.materialAddList.push({ id: item.id, code: str })
        }
      })
    },
    close() {
      this.reast()
      this.$emit('close')
    },
    reast() {
      this.form.resetFields()
      this.count = 1
      this.dataSource = []
      this.cacheData = []
      this.valueMaterial = ''
      this.nameMaterial = ''
      this.chooseVisible = false
      this.editingKey = ''
      this.materialList = []
      this.areaList = [] // 库区列表
      this.locationList = [] // 库位列表
      this.loading = false
      this.canAdd = true
      this.canAddMaterial = true
      this.isPlan = false
      this.planList = [] // 计划列表
      this.inTypeCode = ''
      this.selectPlan = ''
      this.planInfo = {}
      this.customerList = [] // 客户列表
      this.orderList = [] // 工单列表
      this.selectOrder = ''
      this.processList = [] // 工序列表
      this.selectProcess = ''
      this.stockOutOrderList = [] // 出库单列表
      this.isPlanAdd = true
      this.canAddTwo = false
      this.hasOutOrder = false
    },
    checkMaterialBuff() {
      if (this.defaultData.isPlan == 1) {
        this.isPlan = true
        this.selectPlan = this.defaultData.planCode
        const inType = this.stockInList.find((res) => res.id == this.defaultData.stockInTypeId)
        this.inTypeCode = inType ? inType.code : ''
        this.getMaterialList(this.inTypeCode)
      }
      if (this.defaultData.outOrderCode) {
        this.hasOutOrder = true
        this.isPlanAdd = false
        this.canAddMaterial = false
        this.canAdd = false
      }
      this.dataSource = []
      const data = this.addTT(this.defaultData.stockInOrderMaterialVoList) || []
      this.dataSource = data
      this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
      if (this.dataSource.length === 0) {
        this.canAddMaterial = true
      }
    },
    //初始化结束
    getMaterialList(inTypeCode) {
      if (inTypeCode === 'processedStockIn') {
        // 如果入库类型为 在制入库
        msp.getMaterialList(2, '', 2, '').then((res) => {
          this.materialList = res
        })
        this.canAddMaterial = false
      } else {
        this.isPlanAdd = false
        this.canAddMaterial = false
      }
    },

    addTT(data) {
      const value = []
      data.forEach((item, index) => {
        item.key = index
        item.id = item.id
        delete item.editable
        value.push(item)
      })
      return value
    },
    findSupplier(value) {
      const data = this.supplierList.find((res) => res.id === value)
      return data ? data.name : ''
    },
    beforeUpload(file: any) {
      const isGt20M = file.size / 1024 / 1024 > 20
      if (isGt20M) {
        this.$message.error(this.$t('page_my_document_notsupport'))
        return false
      }
    },
    // 文件上传
    handleChangefileName(req, record) {
      let uploadFile = req.file
      let fileOriginalName = uploadFile.name

      const formData = new FormData()
      formData.append('file', uploadFile)

      putFile(
        formData,
        (res) => {
          let fileName = res.data.data.name
          resourceService.statFileUsingGET(fileName).then((statRes: ROfOssFile) => {
            let ossFile = statRes.data

            const newData = [...this.dataSource]
            const target = newData.filter((item) => record.key === item.key)[0]
            if (target) {
              target['fileName'] = fileOriginalName
              target['fileObjectKey'] = ossFile.name
              target['contentType'] = ossFile.contentType
              this.dataSource = newData
            }
          })
        },
        null
      )
    },
    // 删除
    handleDelete(record) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== record.key)
      siomsp.deleteStockInOrderMaterial(record.id).then(() => {
        this.$message.success(this.$t('delete_success'))
        this.$emit('reloadEdit')
      })
      if (this.isPlan && this.inTypeCode === 'processedStockIn') {
        this.canAddTwo = false
      }
      if (this.dataSource.length === 0) {
        this.canAddMaterial = true
      }
    },
    // 编辑
    edit(record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      const area = this.areaList.find((item) => item.id == this.areaId)
      if (area) {
        whlsp.listWarehouseLocationByMaterial(area.id, '', record.materialId).then((res) => {
          this.locationList = res
        })
      }
      this.editingKey = record.key
      if (target) {
        target.editable = true
        this.dataSource = newData
      }
    },
    // 表格内编辑
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    // 编辑库位
    handleChangeLocationId(value, record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let num = 0
      let same = false
      newData.forEach((res) => {
        if (res.locationId === value && record.id === res.id) {
          same = true
        }
      })
      if (same) {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_be_same'))
        return
      }
      whmssp.listWarehouseMaterialStock(value, record.id).then((res) => {
        if (res) {
          num = res.length > 0 ? res[0].locationNum : num
          if (target) {
            target['locationId'] = value
            const area = this.locationList.find((res) => res.id === value)
            target['locationName'] = area.warehouseLocationName
            target['number'] = num + ''
            this.dataSource = newData
          }
        }
      })
    },
    // 保存
    saveTableEdit(key) {
      const newData = [...this.dataSource]
      const newCacheData = [...this.cacheData]
      const target = newData.filter((item) => key === item.key)[0]
      const targetCache = newCacheData.filter((item) => key === item.key)[0]
      if (target.areaId === '') {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_area'))
        return
      }
      if (target.locationId === '') {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_location'))
        return
      }
      if (target.stockInNum === undefined || target.stockInNum === null) {
        this.$message.warning(this.$t('page_material_ware_not_to_total_number'))
        return
      }
      if (!this.hasOutOrder && (target.totalNum === undefined || target.totalNum === null)) {
        this.$message.warning(this.$t('page_material_ware_not_to_stockin_number'))
        return
      }
      if (target && targetCache) {
        delete target.editable
        this.dataSource = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.editingKey = ''
      if (target.isAdd) {
        const data = { ...target }
        delete data.isAdd
        delete data.id
        delete data.key
        siomsp.createStockInOrderMaterial(data).then(() => {
          delete target.isAdd
          this.$message.success(this.$t('page_material_ware_add_success'))
          this.$emit('reloadEdit')
        })
      } else {
        const data = { ...target }
        delete data.key
        siomsp.editStockInOrderMaterial(data).then(() => {
          delete target.editable
          this.dataSource = newData
          Object.assign(targetCache, target)
          this.cacheData = JSON.parse(JSON.stringify(newCacheData))
          this.$message.success(this.$t('page_mdc_setting_edit_success'))
          this.$emit('reloadEdit')
        })
      }

      if (this.isPlan && this.inTypeCode === 'processedStockIn') {
        // 如果入库类型为 在制入库
        this.canAddMaterial = false
      }
    },
    // 取消编辑
    cancelTableEdit(key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataSource = newData
      }
    },
    // 添加物料
    addMaterial() {
      this.chooseVisible = true
    },
    closeChoose() {
      this.chooseVisible = false
    },
    saveChoose() {
      if (this.valueMaterial !== '') {
        const { count, dataSource } = this
        const material = this.materialList.find((res) => res.id === this.valueMaterial)
        const area = this.areaList.find((item) => item.id == this.areaId)
        if (area) {
          whlsp.listWarehouseLocation(area.id, '').then((res) => {
            this.locationList = res
          })
        }
        this.editingKey = dataSource.length
        const newData = {
          key: dataSource.length,
          editable: true,
          id: material.id,
          materialId: material.id,
          barCode: material.barCode,
          materialTypeName: material.typeName,
          materialCode: material.code,
          materialName: material.name,
          batchCode: '',
          isMustCheck: material.isMustCheck,
          materialStandardModel: material.standardModel,
          materialStuff: material.stuff,
          materialUnit: material.unit,
          number: 0,
          totalNum: 0,
          stockInNum: 0,
          price: 0,
          remark: '',
          areaId: area.id,
          areaName: area.name,
          locationId: '',
          locationName: '',
          testResult: null,
          contentType: '',
          fileName: undefined,
          fileObjectKey: undefined
        }
        ;(newData['isAdd'] = true), (newData['orderId'] = this.selectId)
        this.dataSource = [...dataSource, newData]
        this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
        this.count = dataSource.length
        this.valueMaterial = ''
        this.nameMaterial = ''
        this.chooseVisible = false
        if (this.isPlan && this.inTypeCode === 'processedStockIn') {
          this.canAddTwo = true
        }
      } else {
        this.chooseVisible = false
      }
    },
    changeMaterial(value) {
      this.nameMaterial = value
      const material = this.materialList.find((res) => res.id === value)
      this.valueMaterial = material ? material.id : ''
    }
  }
})
